import { apiService } from "./apiService";
import apiRoutes from "./apiRoutes"; // Add your route string here if needed

export const createBadgeRequest = async (payload) => {
  const response = await apiService.post(`${apiRoutes.badgeRequest}`, payload);
  return response.data;
};


export const getAllUserbadges = async ({
  userId = "",

}) => {
  const params = new URLSearchParams({
    userId,
   
  });
  const response = await apiService.get(
    `${apiRoutes.badgeRequest}?${params.toString()}`
  );
  return response.data;
};
